import React from "react"
import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { Box, Typography } from "@mui/material"
import styles from "../../PendingQuestionTable.module.scss"
import { styled } from "@mui/system"
import QuestionRow from "./components/QuestionRow"
import { Col, Row } from "react-bootstrap"
import WeeklyCategoryCard from "../ContestDetails/weeklyCategoryCard"
import { useSelector } from "react-redux"

const StyledTable = styled(Table)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  "& .MuiTableCell-root": {
    padding: "14px 24px 14px 0px",
    backgroundColor: theme.palette.background.main,
    borderBottom: `2px solid ${theme.palette.background.default}`,
    boxSizing: "border-box",
    "&:last-child": {
      paddingRight: 0
    }
  },

  "& .MuiTableCell-head": {
    verticalAlign: "bottom",
    position: "relative",
    "&:last-child": {
      paddingRight: 0
    }
  }
}))

const EditPendingQuestion = ({
  rows = [],
  columns = [],
  contestData,
  isEdit,
  questionCount = []
}) => {
  const [questionCategoryCount, setQuestionCategoryCount] = React.useState([])
  const [selectedCategory, setSelectedCategory] = React.useState("all")
  const [questionsList, setQuestionsList] = React.useState([])
  const { isLoading } = useSelector((state) => state?.app)
  const allSelected = selectedCategory === "all"

  const checkStatus = (index) => {
    if (contestData?.status?.toLowerCase() === "published" && index === columns?.length - 1) {
      const date = new Date(contestData?.start_date)
      return date > new Date()
    }
    return true
  }

  React.useEffect(() => {
    if (!questionCount?.length) return
    const categoryCount = [
      { title: "All", category: "all", count: rows?.length },
      ...questionCount.map((item) => ({
        title: item.category_name,
        category: item.category_id,
        count: item.question_count
      }))
    ]

    setQuestionCategoryCount(categoryCount)
  }, [questionCount, rows])

  React.useEffect(() => {
    if (selectedCategory === "all") {
      setQuestionsList(rows)
    } else {
      setQuestionsList(rows?.filter((question) => question?.category_id === selectedCategory))
    }
  }, [selectedCategory, rows])

  return (
    <Paper className={styles.container}>
      {rows?.length ? (
        <Row>
          <Col lg="12">
            <Box className="d-flex w-100 flex-wrap">
              {questionCategoryCount?.map((option, index) => (
                <WeeklyCategoryCard
                  key={index}
                  title={option?.title}
                  category={option?.category}
                  count={option?.count}
                  handleClick={() => setSelectedCategory(option?.category)}
                  isIncluded={
                    allSelected ? option?.category === "all" : selectedCategory === option?.category
                  }
                />
              ))}
            </Box>
          </Col>
        </Row>
      ) : null}
      {questionsList?.length ? (
        <TableContainer sx={{ maxHeight: 600 }}>
          <StyledTable stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <>
                    {checkStatus(index) ? (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}>
                        <Typography className={styles.header} variant="body2Regular">
                          {column.label}
                        </Typography>
                      </TableCell>
                    ) : null}
                  </>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {questionsList?.map((row, index) => {
                return (
                  <QuestionRow
                    isEdit={isEdit}
                    key={row.id}
                    row={row}
                    index={index}
                    contestData={contestData}
                  />
                )
              })}
            </TableBody>
          </StyledTable>
        </TableContainer>
      ) : (
        <Box className="d-flex justify-content-center align-items-center" height={"40vh"}>
          <Typography variant="h2">
            {isLoading ? "Please wait, we are fetching the questions..." : "No Questions Found"}
          </Typography>
        </Box>
      )}
    </Paper>
  )
}

export default EditPendingQuestion
